import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  let breadcrumbsCarousel = null;
  const breadcrumbs = document.querySelector('.breadcrumbs-carousel');

  if (!breadcrumbs) {
    return;
  }

  enableSwiper();
  verifySwiperLock();
  window.addEventListener('resize', verifySwiperLock);

  function enableSwiper() {
    const breadcrumbLinks = document.querySelectorAll(
      '.breadcrumbs-carousel__item__link'
    );

    if (0 < breadcrumbLinks.length) {
      breadcrumbsCarousel = new Swiper(breadcrumbs, {
        slidesPerView: 'auto',
        spaceBetween: 4,
        watchOverflow: true,
        a11y: {
          slideRole: null,
        },
      });

      breadcrumbLinks.forEach((link) => {
        link.addEventListener('focus', () => {
          const slide = link.closest('.swiper-slide');
          const slideIndex = Array.prototype.indexOf.call(
            breadcrumbs.querySelector('.swiper-wrapper').children,
            slide
          );
          breadcrumbsCarousel.slideTo(slideIndex);
        });
      });
    }
  }

  function verifySwiperLock() {
    if (breadcrumbsCarousel && breadcrumbsCarousel.isLocked) {
      breadcrumbs.classList.add('swiper-locked');
    } else {
      breadcrumbs.classList.remove('swiper-locked');
    }
  }
});
